require.register("documenteditor/directives/documenteditorDirective", function(exports, require, module){
  $0
  
});

